import Policy from '../route/src/crossgateTw/policy/index.vue'
import CrossgateTw from '../route/src/crossgateTw/index.vue'
import Terms from '../route/src/crossgateTw/terms/index.vue'
import Activity01 from '../route/src/prereg/Activity01/index.vue'
import Activity02 from '../route/src/prereg/Activity02/index.vue'
import Activity03 from '../route/src/prereg/Activity03/index.vue'
import Activity04 from '../route/src/prereg/Activity04/index.vue'
import Activity05 from '../route/src/prereg/Activity05/index.vue'
import Activity06 from '../route/src/prereg/Activity06/index.vue'
import Activity07 from '../route/src/prereg/Activity07/index.vue'
import FaceDialog from '../route/src/prereg/components/faceDialog/index.vue'
import Lingliu from '../route/src/lingliu/index.vue'
import LingliuPolicy from '../route/src/lingliu/policy/index.vue'
import LingliuTerms from '../route/src/lingliu/terms/index.vue'



const Components = {
  Lingliu,
  LingliuPolicy,
  LingliuTerms,
  Policy,
  CrossgateTw,
  Terms,
  Activity01,
  Activity02,
  Activity03,
  Activity04,
  Activity05,
  Activity06,
  Activity07,
  FaceDialog
}

export default {
  // 注册全局组件
  install: function (Vue) {
    // 注册全局组件
    for (let k in Object.assign(Components)) {
      if (!Components.hasOwnProperty(k)) {
        continue
      }

      Vue.component(k, Components[k])
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/components.js